"use strict";

var _slicedToArray = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var cov_4a8fqa90x = function () {
  var path = "/Volumes/Github-Projects/gitea-react-toolkit/src/components/application-bar/DrawerMenu.js";
  var hash = "07755365ef35001110c55d1fe805dce3d3ec9325";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/Github-Projects/gitea-react-toolkit/src/components/application-bar/DrawerMenu.js",
    statementMap: {
      "0": {
        start: {
          line: 19,
          column: 18
        },
        end: {
          line: 19,
          column: 29
        }
      },
      "1": {
        start: {
          line: 20,
          column: 38
        },
        end: {
          line: 20,
          column: 53
        }
      },
      "2": {
        start: {
          line: 21,
          column: 25
        },
        end: {
          line: 21,
          column: 54
        }
      },
      "3": {
        start: {
          line: 23,
          column: 23
        },
        end: {
          line: 25,
          column: 3
        }
      },
      "4": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 24,
          column: 31
        }
      },
      "5": {
        start: {
          line: 27,
          column: 24
        },
        end: {
          line: 27,
          column: 54
        }
      },
      "6": {
        start: {
          line: 28,
          column: 2
        },
        end: {
          line: 51,
          column: 4
        }
      },
      "7": {
        start: {
          line: 54,
          column: 0
        },
        end: {
          line: 57,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "DrawerMenu",
        decl: {
          start: {
            line: 16,
            column: 9
          },
          end: {
            line: 16,
            column: 19
          }
        },
        loc: {
          start: {
            line: 18,
            column: 3
          },
          end: {
            line: 52,
            column: 1
          }
        },
        line: 18
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 23,
            column: 23
          },
          end: {
            line: 23,
            column: 24
          }
        },
        loc: {
          start: {
            line: 23,
            column: 29
          },
          end: {
            line: 25,
            column: 3
          }
        },
        line: 23
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 21,
            column: 25
          },
          end: {
            line: 21,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 21,
            column: 25
          },
          end: {
            line: 21,
            column: 48
          }
        }, {
          start: {
            line: 21,
            column: 52
          },
          end: {
            line: 21,
            column: 54
          }
        }],
        line: 21
      },
      "1": {
        loc: {
          start: {
            line: 47,
            column: 9
          },
          end: {
            line: 47,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 47,
            column: 9
          },
          end: {
            line: 47,
            column: 19
          }
        }, {
          start: {
            line: 47,
            column: 23
          },
          end: {
            line: 47,
            column: 40
          }
        }],
        line: 47
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "07755365ef35001110c55d1fe805dce3d3ec9325"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

var _useStyles = require("./useStyles");

var _ = require("..");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function DrawerMenu(_ref) {
  var children = _ref.children;
  cov_4a8fqa90x.f[0]++;
  var classes = (cov_4a8fqa90x.s[0]++, (0, _useStyles.useStyles)());

  var _ref2 = (cov_4a8fqa90x.s[1]++, (0, _react.useState)(false)),
      _ref3 = _slicedToArray(_ref2, 2),
      openDrawer = _ref3[0],
      setOpenDrawer = _ref3[1];

  var _ref4 = (cov_4a8fqa90x.s[2]++, (cov_4a8fqa90x.b[0][0]++, (0, _react.useContext)(_.FileContext)) || (cov_4a8fqa90x.b[0][1]++, {})),
      components = _ref4.components;

  cov_4a8fqa90x.s[3]++;

  var toggleDrawer = function toggleDrawer() {
    cov_4a8fqa90x.f[1]++;
    cov_4a8fqa90x.s[4]++;
    setOpenDrawer(!openDrawer);
  };

  var drawerClasses = (cov_4a8fqa90x.s[5]++, {
    paper: classes.drawerPaper
  });
  cov_4a8fqa90x.s[6]++;
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    "data-test": "drawer-menu-button",
    color: "inherit",
    "aria-label": "Menu",
    onClick: toggleDrawer
  }, /*#__PURE__*/_react.default.createElement(_icons.Menu, null)), /*#__PURE__*/_react.default.createElement(_core.Drawer, {
    className: classes.drawer,
    variant: "temporary",
    anchor: "left",
    open: openDrawer,
    onClose: toggleDrawer,
    classes: drawerClasses
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.drawerHeader
  }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    "data-test": "drawer-menu-close-button",
    onClick: toggleDrawer
  }, /*#__PURE__*/_react.default.createElement(_icons.ChevronLeft, null))), /*#__PURE__*/_react.default.createElement(_core.Divider, null), children, /*#__PURE__*/_react.default.createElement(_core.Divider, null), (cov_4a8fqa90x.b[1][0]++, components) && (cov_4a8fqa90x.b[1][1]++, components.browse), /*#__PURE__*/_react.default.createElement(_core.Divider, null)));
}

;
cov_4a8fqa90x.s[7]++;
DrawerMenu.propTypes = {
  /** Component to render inside of the drawer menu. */
  children: _propTypes.default.element
};
var _default = DrawerMenu;
exports.default = _default;